import { Box, Flex } from '@chakra-ui/react'
import React from 'react'
import IconFolderEmpty from '~/assets/svgs/icon-folder-empty.svg?react'
import { textStyleKeys } from '~/themes/textStyles'

import { ApiError } from '@mangovoice/types'

const ResourceFailedToLoadNoticeWrapper = ({ children, ...props }) => (
  <Flex
    flex={1}
    alignItems="center"
    justifyContent="center"
    width="100%"
    userSelect="none"
    backgroundColor={'gray.200'}
    {...props}
  >
    {children}
  </Flex>
)

const ImageWrapper = ({ children, ...props }) => (
  <Box marginBottom="26px" {...props}>
    {children}
  </Box>
)

const ResourceFailedToLoadContentWrapper = ({ children, ...props }) => (
  <Flex flexDirection="column" alignItems="center" {...props}>
    {children}
  </Flex>
)

const ResourceFailedToLoadTextWrapper = ({ children, ...props }) => (
  <Flex
    alignItems="flex-start"
    justifyContent="center"
    height="62px"
    width="875px"
    {...props}
  >
    {children}
  </Flex>
)

const handleErrorText = (error?: ApiError) => {
  return (
    <Flex
      flexDirection={'column'}
      width={'100%'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      <Flex
        textStyle={textStyleKeys.Body1_Bold}
        color={'gray.1300'}
        textAlign={'center'}
      >
        {(() => {
          if (error?.status === 403) {
            return "You don't have permission to access this voicemail box"
          } else if (error?.status === 410) {
            return 'Voicemail deleted'
          } else {
            return 'Voicemail unavailable'
          }
        })()}
      </Flex>
      <Flex
        textStyle={textStyleKeys.Body1}
        color={'gray.1300'}
        textAlign={'center'}
      >
        {error?.status === 403
          ? 'To get access, contact your system administrator'
          : ''}
      </Flex>
    </Flex>
  )
}

export const ResourceFailedToLoadNotice = ({ error }: { error?: ApiError }) => {
  return (
    <ResourceFailedToLoadNoticeWrapper>
      <ResourceFailedToLoadContentWrapper>
        <ImageWrapper>
          <IconFolderEmpty height={49} width={66} />
        </ImageWrapper>
        <ResourceFailedToLoadTextWrapper>
          {handleErrorText(error)}
        </ResourceFailedToLoadTextWrapper>
      </ResourceFailedToLoadContentWrapper>
    </ResourceFailedToLoadNoticeWrapper>
  )
}
